import { useCallback } from "react";
import ReduxFetchState from "redux-fetch-state";
import { put, takeEvery } from "redux-saga/effects";
import axios from "../../../../Utils/axiosConfig";
import { getCurrentLanguage } from "../../../../Utils/sagaHelpers";
import { useAppDispatch, useAppSelector } from "../../../../Hooks/useStore";
import { alert } from "../../../../Utils/toast";

export type UpdateAvatarLoadAction = {
  type: string;
  payload: { avatar: string };
};

export type UpdateAvatarData = {
  data: {
    message: string;
    avatar: string;
  };
};

const UpdateAvatar = new ReduxFetchState<UpdateAvatarData, { avatar: string }, any>("updateAvatar");

export function* watchUpdateAvatar(action: UpdateAvatarLoadAction) {
  try {
    const lang: "fa" | "en" = yield getCurrentLanguage();
    const { avatar } = action.payload;
    const formData = new FormData();
    formData.append("avatar", avatar);

    console.log(avatar, "avatar");
    const data: UpdateAvatarData = yield axios({
      url: `/api/v1/users/profile/update/avatar`,
      method: "POST",
      headers: {
        lang,
        "Content-Type": "multipart/form-data",
      },
      data: formData,
    });
    alert({ message: data?.data?.message ?? "مشکلی پیش آمده", type: "success" });
    yield put(UpdateAvatar.actions.loadSuccess({ data: data.data }));
  } catch (e: any) {
    alert({ message: e?.response?.data?.message ?? "مشکلی پیش آمده", type: "error" });
    yield put(UpdateAvatar.actions.loadFailure(e.message));
  }
}

export function* updateAvatarSagas() {
  yield takeEvery(UpdateAvatar.actionTypes.load, watchUpdateAvatar);
}

export function useUpdateAvatar() {
  const { loading, data, ...updateAvatarState } = useAppSelector((state) => state.updateAvatar);

  const dispatch = useAppDispatch();

  const dispatchUpdateAvatar = useCallback(
    (data: { avatar: string }) => {
      dispatch(UpdateAvatar.actions.load(data));
    },
    [dispatch],
  );

  return {
    ...updateAvatarState,
    dispatchUpdateAvatar,
    updateAvatarLoading: loading,
    updateAvatarData: data,
  };
}

export const {
  actionTypes: updateAvatarActionsTypes,
  actions: updateAvatarActions,
  reducer: updateAvatarReducer,
} = UpdateAvatar;